import { css } from '@emotion/core';

import {
  SPACE_MINIMUM,
  displayInlineBlock,
  flexCenter,
  spaceGapCompact,
  spaceGapMinimum,
} from '@/styles';

export const enlargedIconStyles = css`
  transform: scale(1.25);
  ${flexCenter};
`;

export const tabTitleStyles = [
  displayInlineBlock,
  flexCenter,
  spaceGapMinimum,
  css`
    padding-bottom: ${SPACE_MINIMUM}px;
  `,
];

export const tabWithLinkTitleStyles = [flexCenter, spaceGapCompact];

export const tabWithLinkStyles = css`
  a {
    text-decoration: none;
    color: inherit;
    padding: 2px ${SPACE_MINIMUM}px;
    display: block;
  }
`;
